import common from './common'
import debugHelper from '../../util/debug'
import { obtainImage } from '../../util/image'
import tools from '../../util/tools'
import dbHelper from '../../util/db'
import { ROLES } from '../../config/Role'
import functions from '../../functions'
import i18n from '../../lang/index'


var app = {
  funcSetTimer: function (vm, funcList) {
    debugHelper.log('funcSetTimer, 启动定时器, 定时获取角标内容')

    // 1、先执行一次
    debugHelper.log('App, fetchTaskNum: 获取未处理任务数')
    functions.work.funcFetchTaskForBadge(vm, null, true)

    // 2、计时循环执行
    var timer = vm.getTimer()
    // android平台由极光推送来推送消息, 不需要设定定时器去主动拉取
    // if (vm.getPlatform() != 'Android') {
    // 如果存在定时器, 先清空该定时器
    if (timer != null && timer != 0) {
      clearInterval(timer)
    }
    // 设定定时器, 其定时去获取角标内容
    timer = setInterval(() => {
      debugHelper.log('App, fetchTaskNum: 获取未处理任务数')
      functions.work.funcFetchTaskForBadge(vm, null, true)
    }, 60 /* 秒 */ * 1000)
    funcList[0].params.timer = timer
    vm.setTimer(timer)
    // }
    common.callNextFunc(vm, funcList)
  },

  /**
     * 根据用户角色创建底部导航栏Bottom
     * @param {*} vm
     * @param {*} funcList
     */
  funcCreateBottomsByRoles: function (vm, funcList) {
    console.log('调式代码')
    debugHelper.log('funcCreateBottomsByRoles: 根据用户设置Bottom')
    funcList = funcList[0].setParams(funcList)

    var params = funcList[0].params
    var rolesLogin = params.roles

    debugHelper.log(rolesLogin)
    if (rolesLogin == null) {
      vm.setBottomNavButtons({ value: ROLES['others'].bottomNavs })
      vm.setBottomActiveBtn({ value: vm.getBottomNavButtons()[0].name })
    } else {
      // 判断是否有不在角色列表中的角色
      var failedFlag = false
      rolesLogin.forEach(role => {
        if (ROLES[role.roleID] == null) {
          debugHelper.log(`未知角色:${role.name}(${role.roleID}), 登录失败`)
          // 清空localstorage里用户相关的数据，包含清token
          dbHelper.restore()
          // 跳转登陆页面
          vm.$router.replace({ name: 'pwdlogin' })
          // 抛出消息异常
          var err = new Object()
          err.type = 'localError'
          err.prefix = 'login:'
          err.text = 'user has unknown role'
          tools.showTips(vm, err)
          failedFlag = true
        }
      })

      if (failedFlag) {
        return
      }

      //用户拥有多个角色
      if (rolesLogin.length > 1) {
        // 合并用户的角色底部按钮数组, 转化为集合去重
        var bottomNavs = new Array(0)
        rolesLogin.forEach(role => {
          ROLES[role.roleID].bottomNavs.forEach(bottomNav => {
            bottomNavs.push(bottomNav)
          })
        })

        // 利用集合去重再恢复数组
        bottomNavs = Array.from(new Set(bottomNavs))

        // 并且进行排序
        bottomNavs.sort(common.compareForBottomNav('id'))

        vm.setBottomNavButtons({ value: bottomNavs })
      } else if (rolesLogin.length == 1) {
        //仅拥有一个角色
        vm.setBottomNavButtons({
          value: ROLES[rolesLogin[0].roleID].bottomNavs
        })
      } else {
        //0个角色的情况
        vm.setBottomNavButtons({ value: ROLES['others'].bottomNavs })
      }
      vm.setBottomActiveBtn({ value: vm.getBottomNavButtons()[0].name })
    }

    funcList[0].getResult(funcList)

    common.callNextFunc(vm, funcList)
  },
  /**
   * 根据角色选择跳转页面
   * @param {*} vm
   * @param {*} funcList
   */
  funcSelectPageByRole: function (vm, funcList) {
    console.log('调试代码')
    if (vm == null) {
      return
    }

    debugHelper.log('funcSelectPageByRole: 根据用户跳转页面')

    //跳转页面
    // if (
    //   !vm.getIsPwd() &&
    //   (vm.getAccountInfo().needResetPsw || dbHelper.get('haveResetPwd') == null)
    // ) {
    //   vm.$router.replace({ name: 'setpwd' })
    // } else {
    //跳转页面
    vm.setBottomNavVisible(true)
    vm.setBottomActiveBtn({ value: vm.getBottomNavButtons()[0].name })
    vm.$router.replace({ name: vm.getBottomNavButtons()[0].click.params })
    // }
    common.callNextFunc(vm, funcList)
  },

  /**
   * 根据用户权限设置应用权限
   * @param {*} vm
   * @param {*} funcList
   */
  funcMapRightsFromRoles: function (vm, funcList) {
    console.log('调试代码')
    if (vm == null) {
      return
    }

    debugHelper.log('funcMapRightsFromRoles: 根据用户权限设置应用权限')
    try {
      let roleRightsLogin = vm.getUserRoleRights()
      vm.setCurButtonRights(roleRightsLogin)
    } catch (err) {
      vm.setSnackBar({
        value: {
          color: 'error',
          text: i18n.t('读取权限异常'),
          visible: true
        }
      })
      return
    }
    funcList[0].getResult(funcList)
    common.callNextFunc(vm, funcList)
  },

  /**
   * 跳转页面
   * @param {*} vm
   * @param {*} funcList
   */
  funcChangePage: function (vm, funcList) {
    debugHelper.log('funcChangePage: 跳转页面')
    vm.setBottomNavVisible(true)
    vm.setBottomActiveBtn({ value: vm.getBottomNavButtons()[0].name })
    vm.$router.replace({ name: vm.getBottomNavButtons()[0].click.params })

    common.callNextFunc(vm, funcList)
  },

  /**
   * 返回前页
   * @param {*} vm
   * @param {*} funcList
   */
  funcRouterBack: function (vm, funcList) {
    debugHelper.log('funcRouterBack: 返回前页')
    funcList[0].setParams(funcList)
    vm.setBackDisabled(true)
    vm.$router.back()
    common.callNextFunc(vm, funcList)
  },

  /**
   * 页面切换
   * @param {*} vm
   * @param {*} funcList
   */
  funcRouterReplace: function (vm, funcList) {
    funcList = funcList[0].setParams(funcList)
    var pageName = funcList[0].params.pageName
    debugHelper.log(`funcRouterReplace: 前往${pageName}`)
    vm.$router.replace({ name: pageName })
    common.callNextFunc(vm, funcList)
  },

  /**
   * 获取百度语音Token
   * @param {*} vm
   * @param {*} funcList
   */
  funcFetchTTSToken: function (vm, funcList) {
    debugHelper.log('funcFetchTTSToken: 获取百度语音token')
    funcList = funcList[0].setParams(funcList)
    vm.fetchTTSToken({
      vm: vm,
      authorization: {
        Authorization: 'Bearer ' + vm.getAccountToken()
      }
    }).then(() => {
      // 获取成功
      debugHelper.log('获取成功')
      common.callNextFunc(vm, funcList)
    })
  },


  // 申请Android系统文件读写权限
  funcRequestPermissions: function (vm, funcList) {
    if (vm.getPlatform() == 'Android') {
      //先申请读取拌机文件权限
      var permissions = window.cordova.plugins.permissions
      var permissionsStorage = [
        permissions.WRITE_EXTERNAL_STORAGE,
        permissions.READ_EXTERNAL_STORAGE
      ]

      permissions.checkPermission(
        // permissionsStorage,
        permissions.WRITE_EXTERNAL_STORAGE,
        function (s) {
          //hasPermission 验证是否成功
          if (!s.hasPermission) {
            //没有权限
            //app申请写入权限
            permissions.requestPermission(
              // permissionsStorage,
              permissions.WRITE_EXTERNAL_STORAGE,
              function (s) {
                if (s.hasPermission) {
                  //申请成功
                  vm.setSnackBar({
                    value: {
                      color: 'success',
                      text: i18n.t('文档操作权限申请成功'),
                      visible: true,
                    },
                  })
                } else {
                  vm.setSnackBar({
                    value: {
                      color: 'error',
                      text: i18n.t('文档操作权限申请失败，影响文档预览功能'),
                      visible: true
                    }
                  })
                }
                common.callNextFunc(vm, funcList)
              },
              function (error) {
                common.callNextFunc(vm, funcList)
              }
            )
          } else {
            common.callNextFunc(vm, funcList)
          }
        },
        function (error) {
          common.callNextFunc(vm, funcList)
        }
      )
    } else {
      common.callNextFunc(vm, funcList)
    }
  },

  // APK版本升级检查
  funceCheckAPKUpdate: function (vm, funcList) {
    if (vm.getPlatform() != 'browser') {
      // 获取服务端版本信息
      functions.versionCheckHelper.funcGetAppServerVersion()

      // 检查大版本更新（若有新版本，则提示需更新）
      functions.versionCheckHelper.funcCheckAPKUpdate()
    }
    common.callNextFunc(vm, funcList)
  },

  // 打开第三方预览文件申请的文件
  funcEdsFileView: function (vm, funcList) {
    if (vm.getPlatform() === 'iOS') {
      functions.edsfileview.GetOpenAsFileName()
    } else {
      functions.edsfileview.funcEdsFileOpen()
    }

    common.callNextFunc(vm, funcList)
  },
}

export default app
